<template>
  <div class="transactionItem">
    <div class="transactionItem__info">
      <div class="transactionItem__info__orderid">
        <div class="transactionItem__info__orderid__id">
          <p class="small-font">
            Order ID
          </p>
          <h3 class="subhead">
            {{item.number}}
          </h3>
          <p class="small-font">
            {{formatDate(item.createdAt)}}
          </p>
        </div>
        <!-- <div class="transactionItem__info__orderid__duedate" v-if="item.payment.dueDate">
          <p class="small-font">
            Due date on :
          </p>
          <p class="small-font color-pink">
            {{formatDate(item.payment.dueDate)}}
          </p>
        </div> -->
      </div>
      <div class="transactionItem__info__number">
        <div class="transactionItem__info__number__campaign">
          <p class="small-font">
            Number of campaign
          </p>
          <h3 class="subhead">
            1 Campaign
          </h3>
        </div>
      </div>
      <div class="transactionItem__info__payment">
        <div class="transactionItem__info__payment__status">
          <p class="small-font">
            Transaction status
          </p>
          <h3 class="subhead" :class="colorStatus(item.payment.statusDisplay)">
            {{item.payment.statusDisplay == 'Pending' ? 'Pending' : item.payment.statusDisplay}}
          </h3>
        </div>
      </div>
      <div class="transactionItem__info__total">
        <div class="transactionItem__info__total__price">
          <p class="small-font">
            Total price :
          </p>
          <h3 class="subhead">
            {{priceToInt(item.campaign.totalPrice) | formatMoney}}
          </h3>
        </div>
      </div>
      <div class="transactionItem__info__action">
        <router-link :to="{name:'orderdetailexecution', params: { id: item.id }}" class="btn-action" target= '_blank'>
          <button class="btn-regular secondary orderdetail">Order Detail</button>
        </router-link>
      </div>
      <div class="transactionItem__info__dropdown"  @click.stop="toggle">
        <span v-if="isOpen" class="dropdown-show">Show Less</span>
        <span v-else class="dropdown-show">Show More</span>
      </div>
    </div>
    <div class="transactionItem__list" v-if="isOpen">
      <adx-transaction-list :key="item.campaign.id" :campaign="item.campaign" 
      :orderStatus="item.status.title"/>
    </div>
  </div>
</template>

<script>
import TransactionList from '@/views/Transaction/BusAdvertising/TransactionItem/List'


import api from '@/api'
import { apiV2 } from '@/api/urls'
import { formatShortDateTime } from '@/lib/util'

export default {
  name: 'adx-transaction-item',
  components: {
    'adx-transaction-list': TransactionList
  },
  props: {
    item: {
      required: false
    }
  },
  data() {
    return {
      isOpen: false
    }
  },
  computed: {
    
  },
  watch: {

  },
  beforeCreate() {

  },
  created() {
   
  },
  beforeMount() {

  },
  mounted() {
    
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen
    },
    colorStatus(status) {
      if (status == 'Pending'){
        return 'color-sunrise'
      }else if(status == 'Paid'){
        return 'color-lightgreen'
      }else if(status == 'Partially' || status == 'DownPayment' ){
        return 'color-red'
      }else {
        return 'color-black color'
      }
    },
    priceToInt(value){
      return parseInt(value)
    },
    formatDate(date) {
      return formatShortDateTime(date)
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>